window.addEventListener("DOMContentLoaded", (ev) => {
  const swiper = new Swiper(".section__image-slider", {
    spaceBetween: 0,
    disableOnInteraction: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    duration: 800,
    loop: true,
    navigation: {
      nextEl: ".image-slider__button--next",
      prevEl: ".image-slider__button--prev",
    },
  });
});
